// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownLinks_wrapper__VDgAk","button":"DropdownLinks_button__V8mXt","dropdown":"DropdownLinks_dropdown__LiVVF"};